import React, { FC } from 'react';
import { PartnersCommissions } from './PartnersCommissions';
import { AgenciesCommissions } from './AgenciesCommissions';

export const Commissions: FC = () => {
	return (
		<>
			<PartnersCommissions/>
			<AgenciesCommissions/>
		</>
	);
};